import { render, staticRenderFns } from "./NewUserForm.vue?vue&type=template&id=d7460e0c&scoped=true"
import script from "./NewUserForm.vue?vue&type=script&lang=js"
export * from "./NewUserForm.vue?vue&type=script&lang=js"
import style0 from "./NewUserForm.vue?vue&type=style&index=0&id=d7460e0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7460e0c",
  null
  
)

export default component.exports